(function () {
  'use strict';

  angular
    .module('paymentPlannedActual')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('paymentPlannedActual', {
        url: '/planned-actual-payment-report',
        views: {
        	'paymentView' : {
        		templateUrl: 'payment-planned-actual/views/payment.tpl.html',
                controller: 'paymentPlannedActualCtrl',
                controllerAs: 'paymentPlannedActual'
        	}
        }
      });
  }
}());
